import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-gallery-fullscreen/jb-gallery-fullscreen.css.ts
var jb_gallery_fullscreen_css_default = i`:host{display:block;width:100%}:host>div{opacity:0}div{height:100%}.aspect-3by2{margin-inline:16%}.aspect-4by3{margin-inline:20%}.aspect-16by9{margin-inline:10%}.aspect-21by9{margin-inline:10%}.aspect-2by3,.aspect-3by4,.aspect-9by16{margin-inline:28%}`;

export {
  jb_gallery_fullscreen_css_default
};
